import '@tencent/tea-component/dist/tea.css';
import 'portal-common-account/src/styles/global.scss';

import { css } from '@emotion/css';
import { Modal } from '@tencent/tea-component';

import { LoginContainer } from './LoginContainer';

export const loginModal = (options, resolve, reject) => {
  const { destroy } = Modal.show({
    className: dialogWrap,
    size: 'xl',
    children: <LoginContainer resolve={resolve} reject={reject} {...options} />,
    onClose: () => {
      resolve({ login: false, type: 'cancel' });
    },
  });

  return destroy;
};

export const login = (options) => {
  return new Promise((resolve, reject) => {
    const destroy = loginModal(
      options,
      (data) => {
        resolve(data || { login: true, type: 'confirm' });
        destroy && destroy();
      },
      reject,
    );
  });
};

const dialogWrap = css`
  .tea-dialog__footer {
    display: none;
  }
`;
